import { OpenBook } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconOpenBook12Line = createIcon(OpenBook, 12, "Line");
export const IconOpenBook16Line = createIcon(OpenBook, 16, "Line");
export const IconOpenBook20Line = createIcon(OpenBook, 20, "Line");
export const IconOpenBook24Line = createIcon(OpenBook, 24, "Line");
export const IconOpenBook32Line = createIcon(OpenBook, 32, "Line");
export const IconOpenBook48Line = createIcon(OpenBook, 48, "Line");
export const IconOpenBook64Line = createIcon(OpenBook, 64, "Line");
